document.addEventListener('DOMContentLoaded', () => {

	// 共通で使用する要素
	const header = document.querySelector('header.pageHeader');
	const body = document.body;

	/* --------------------------------------------------------------------------
		Step Slider (Intersection Observer & Scroll Control)
	-------------------------------------------------------------------------- */
	const setupStepSlider = () => {
		const viewport = document.querySelector('.stepSlider__viewport');
		const slides   = document.querySelectorAll('.stepSlider__item');
		const dots     = document.querySelectorAll('.pagination-dot');
		const btnPrev  = document.querySelector('.stepSlider__arrow.--prev');
		const btnNext  = document.querySelector('.stepSlider__arrow.--next');

		if (!viewport || slides.length === 0) return;

		const goToSlide = (index) => {
			const slideWidth = slides[0].offsetWidth;
			viewport.scrollTo({
				left: slideWidth * index,
				behavior: 'smooth'
			});
		};

		dots.forEach((dot, index) => {
			dot.addEventListener('click', () => goToSlide(index));
		});

		btnPrev?.addEventListener('click', () => {
			viewport.scrollBy({ left: -viewport.offsetWidth, behavior: 'smooth' });
		});
		btnNext?.addEventListener('click', () => {
			viewport.scrollBy({ left: viewport.offsetWidth, behavior: 'smooth' });
		});

		const observerOptions = {
			root: viewport,
			threshold: 0.6
		};
		
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const index = Array.from(slides).indexOf(entry.target);
					
					dots.forEach(dot => dot.classList.remove('is-active'));
					if (dots[index]) dots[index].classList.add('is-active');

					if (btnPrev && btnNext) {
						btnPrev.disabled = (index === 0);
						btnNext.disabled = (index === slides.length - 1);
					}
				}
			});
		}, observerOptions);

		slides.forEach(slide => observer.observe(slide));
	};


	/* --------------------------------------------------------------------------
		Read More Accordion (Generic Control)
	-------------------------------------------------------------------------- */
	const setupReadMoreAccordions = () => {
		const readMoreBtns = document.querySelectorAll('.button-readmore');

		readMoreBtns.forEach(btn => {
			const targetId = btn.getAttribute('aria-controls');
			const targetContent = document.getElementById(targetId);

			if (!targetContent) return;

			btn.addEventListener('click', () => {
				const isExpanded = btn.getAttribute('aria-expanded') === 'true';
				const newState = !isExpanded;

				btn.setAttribute('aria-expanded', newState);
				targetContent.setAttribute('aria-expanded', newState);
				targetContent.classList.toggle('is-opened', newState);

				if (!newState) {
					const parentSection = targetContent.closest('section') || targetContent;
					const headerHeight = header ? header.offsetHeight : 0;
					// スムーズスクロール。固定ヘッダ分を考慮
					const targetPos = parentSection.getBoundingClientRect().top + window.pageYOffset - headerHeight;
					window.scrollTo({ top: targetPos, behavior: 'smooth' });
				}
			});
		});
	};


	/* --------------------------------------------------------------------------
		Global Navigation & Anchor Scroll
	-------------------------------------------------------------------------- */
	const setupNavigation = () => {
		const menuBtn = document.querySelector('.menu');
		const nav = document.querySelector('.nav-global');

		if (!menuBtn || !nav) return;

		// メニューの開閉
		const toggleMenu = (forceState) => {
			const isOpening = (forceState !== undefined) ? forceState : !body.classList.contains('is-menu-open');
			
			if (isOpening) {
				// 開くときは即座にbodyにクラスをつける（スクロール禁止など）
				body.classList.add('is-menu-open');
				nav.classList.add('is-active');
			} else {
				// 閉じるときはまずナビのクラスだけ外す
				nav.classList.remove('is-active');

				// transitionが完了するのを一度だけ待ってからbodyのクラスを外す
				nav.addEventListener('transitionend', () => {
					body.classList.remove('is-menu-open');
				}, { once: true });
			}
		};

		menuBtn.addEventListener('click', () => toggleMenu());

		// ページ内リンクの制御（イベント委譲）
		document.addEventListener('click', (e) => {
			const link = e.target.closest('a[href^="#"]');
			if (!link) return;

			const href = link.getAttribute('href');
			if (href === '#' || href === '') return;

			const target = document.querySelector(href);
			if (target) {
				e.preventDefault();

				// ナビゲーション内リンクならメニューを閉じる
				if (nav.contains(link)) {
					toggleMenu(false);
				}

				const headerHeight = header ? header.offsetHeight : 0;
				const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
				
				window.scrollTo({
					top: targetPosition - headerHeight,
					behavior: 'smooth'
				});
			}
		});
	};


	/* --------------------------------------------------------------------------
		Initialize
	-------------------------------------------------------------------------- */
	setupStepSlider();
	setupReadMoreAccordions();
	setupNavigation(); // GlobalNavとAnchorScrollを統合しました

});